import { render, staticRenderFns } from "./NewStowageEditRX.vue?vue&type=template&id=91294680&scoped=true&"
import script from "./NewStowageEditRX.vue?vue&type=script&lang=js&"
export * from "./NewStowageEditRX.vue?vue&type=script&lang=js&"
import style0 from "./NewStowageEditRX.vue?vue&type=style&index=0&id=91294680&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91294680",
  null
  
)

export default component.exports